import axios, { AxiosResponse } from "axios";
import { API_URL } from "../config/appConfig";
import { localStorageService } from "../services";
import { ApiResponse } from "../models/Response/apiResponse";
import localization from "../config/localization";
import errorModal from "../services/errorModal.service";

const apiClient = axios.create({
  baseURL: API_URL,
});

apiClient.interceptors.request.use((config) => {


  config.headers["X-Client-Domain"] = "User"

  if (!config.headers["Content-Type"]) {
    config.headers["Content-Type"] = "application/json";
  }

  const requiresAuth = (config.headers as any)?.requiresAuth !== false;
  if (requiresAuth) {
    const token = localStorageService.getItem<string>("token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
  }
  return config;
});

apiClient.interceptors.response.use(
  <T>(response: AxiosResponse<ApiResponse<T>>) => {
    const { meta } = response.data;
    if (meta?.statusCode !== 200) {
      return {
        ...response,
        data: {
          isSuccess: false,
          statusCode: meta?.statusCode,
          message: meta?.message || "Something went wrong",
          data: null,
        },
      };
    }

    return {
      ...response,
      data: {
        isSuccess: true,
        statusCode: meta?.statusCode,
        message: meta?.message || "Success",
        data: response?.data?.data,
      },
    };
  },
  (error) => {
    if (error?.response?.status === 401) {
      localStorageService.clear();
      window.dispatchEvent(new Event("authChange"));
      errorModal.showErrorModal(error?.response?.status, localization.session_error_model, false);
      return {
        data: {
          isSuccess: false,
          statusCode: error?.response?.status,
          message: localization.session_error_model,
          data: null,
        },
      };
    } else {
      const messageKey =
        error?.response?.data?.meta?.message?.[0] ?? "Something went wrong";

      let message = messageKey;

      if (messageKey in localization) {
        message = localization.getString(
          messageKey as keyof typeof localization
        );
      }

      return {
        data: {
          isSuccess: false,
          statusCode: error?.response?.status,
          message: message,
          data: null,
        },
      };
    }
  }
);

export default apiClient;
